
<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="brokers">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ brokers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : brokers.length }} of {{ brokers.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key=""></vs-th>
        <vs-th sort-key="name">Broker Name</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="mobile">Mobile Number</vs-th>
        <vs-th sort-key="address">Address</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <vs-avatar v-if="tr.image" size="large" :src="tr.image" />
            <vs-avatar v-else size="large" src="https://lemonspaces.com/frontend/images/broker.png"  style="background:#FFFFFF;"/>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.name}}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.email}}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.mobile}}</p>
          </vs-td>
          <vs-td>
            <p class="product-name font-bold">{{tr.address}}</p>
          </vs-td>
          <vs-td style="width: 160px;">
            <div class="vx-row">
              <feather-icon icon="EditIcon" @click="editRow(tr.id)" class="cursor-pointer navbar-fuzzy-search ml-4 text-success"></feather-icon>
              <feather-icon icon="TrashIcon" @click="deleteRow(tr.id)" class="cursor-pointer navbar-fuzzy-search ml-4 text-danger"></feather-icon>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    data() {
      return {
        itemsPerPage: 5,
        isMounted: false,
        stats: {},
        profileData: {}
      }
    },
    async created() {
      this.$vs.loading({ text: 'Loading All Brokers' })
      await this.loadAllBrokers({
        storeName: 'brokers',
        url: `admin/brokers`,
        commitUrl: 'brokers/SET_BROKERS',
      })
      // console.log(this.brokers)
      this.$vs.loading.close()
    },
    computed: {
      ...mapGetters({
        brokers: 'brokers/brokersList',
        isLoading: 'brokers/isLoading',
        error: 'brokers/error',
      }),
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    methods: {
      ...mapActions({
        loadAllBrokers: 'get',
        deleteBroker: 'delete',
      }),
      errorNotify(){
        this.$vs.notify({color:'danger', title:'Error', text:this.error})
      },
      deleteRow(id) {
        this.deleteBroker({
          id: id,
          url: `admin/brokers`,
          dispatch_Func: 'brokers/deleteRow',
          dispatch_data: {
            id: id
          },
          storeName: 'brokers',
          needLoading: true
        })
      },
      editRow(brokerID) {
        this.$router.replace({
          name: 'edit-broker',
          params: { brokerID: brokerID }
        })
      }
    },
    watch: {
      isLoading(newValue) {
        if (newValue) {
          this.$vs.loading()
        }else {
          this.$vs.loading.close()
        }
      },
      error(newValue) {
        if (newValue != null) {
          this.errorNotify()
        }
      }
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 8px 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
